'use client';

import { Children } from 'react';
import { Box } from '../../Box';
import { getCarouselChildWrapperStyles, getCarouselFlexWrapperStyles } from '../styles';
import type { CarouselType } from '../types';
import { CarouselWrapper } from './CarouselWrapper';

/**
 * Carousel Component based on https://www.embla-carousel.com
 */
export const Carousel = ({ children, visibleSlides = 1, gap = 0, ...props }: CarouselType) => (
  <CarouselWrapper {...props}>
    <Box sx={getCarouselFlexWrapperStyles(gap)}>
      {Children.map(children, (child, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Box key={index} sx={getCarouselChildWrapperStyles(visibleSlides, gap)}>
          {child}
        </Box>
      ))}
    </Box>
  </CarouselWrapper>
);
